import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SnackService } from './snack.service';
import { UserdataService } from './userdata.service';
import { CookieService } from 'ngx-cookie-service';
import { serverurl } from '../../environments/environment';
import { GenericStreamService } from './generic-stream.service';
import { MentorDetailsForRegistration } from '../interfaces/responsedata.ts/mentor';

@Injectable({
    providedIn: 'root'
})
export class AuthandregistryService {
    constructor(
        private http: HttpClient,
        private router: Router,
        private mysnack: SnackService,
        private userdata: UserdataService,
        private cookieService: CookieService,
        private genericStreamService: GenericStreamService
    ) { }

    async promotionCheck(promotionId: string): Promise<unknown | number> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/auth/promotion/${promotionId}`)
                .subscribe({
                    next: (data: any) => {
                        resolve(data);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });
        });
    }

    async confirmEmail(confirmId: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            console.log('serverurl', serverurl);

            this.http.post(`${serverurl}/auth/confirm/${confirmId}`, { confirmId: confirmId })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data.msg);
                        this.navigateByRole(data);
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });

        })
    }
    async checkPasswordLink(resetId: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/checkpwlink`, { resetId: resetId })
                .subscribe({
                    next: (data: any) => {
                        resolve(true);
                    },
                    error: (err: any) => {
                        resolve(false);
                    }
                });
        })
    }
    async setNewPassword(resetId: string, password: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/setnewpw`, { resetId: resetId, password: password })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data.msg);
                        if (data.userdata) {
                            this.saveAndRedirect(data);
                            this.navigateByRole(data);
                            resolve(true);
                        }
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });
        })
    }

    async changePassword(password: string, oldPassword: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/changepw`, { password, oldPassword })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data);
                        if (data.userdata?.token) {
                            this.saveAndRedirect(data);
                            this.navigateByRole(data);
                            resolve(true);
                        }
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                })
        })
    }

    async new2faCode(useremail: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/new2fa`, { email: useremail })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data);
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });

        });
    }

    async verify2fa(verifyId: string, verifyCode: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/verify`, { verifyId: verifyId, verifyCode: verifyCode })
                .subscribe({
                    next: async (data: any) => {
                        this.saveAndRedirect(data);
                        this.navigateByRole(data);

                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });

        })
    }

    async doAutoLogin(): Promise<{ [key: string]: unknown } | boolean | number> {
        let userId, apiKey;

        userId = localStorage.getItem('idea_userId');
        apiKey = localStorage.getItem('idea_apiKey');

        if (!userId || !apiKey) {
            return false;
        }

        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/autologin`, { userId: userId, apiKey: apiKey })
                .subscribe({
                    next: async (data: any) => {
                        this.saveAndRedirect(data);
                        await this.navigateByRole(data);
                        resolve(data);
                    },
                    error: (err: HttpErrorResponse) => resolve(err.status),
                });
        })
    }

    private async navigateByRole(data: any | null): Promise<boolean> {
        let role;
        if (!data) {
            role = await this.userdata.getUserDataByKey("role");
        } else {
            role = data.userdata.role;
        }

        // console.log('role', role);
        const user = role.find((r: string) => r.indexOf("USER") !== -1)

        if (user) {
            console.log("USER role identified");

            this.router.navigate(['/home', 'user']);
            return true;
        }

        const mentor = await role.find((r: string) => r === "STARTUP_MENTOR");

        if (mentor) {
            console.log("STARTUP_MENTOR role identified");

            this.router.navigate(['/home', 'mentor']);
            return true;
        }

        const coach = await role.find((r: string) => r === "ST_COACH");

        if (coach) {
            console.log("ST_COACH role identified");

            this.router.navigate(['home', 'mentor']);
            return true;
        }

        this.router.navigate(['/home', 'user']);
        return true;

        // this.snack.error({ error: { msg: { text: "No role", headline: "Your account has no valid role, please contact our support." } } });
        // return false;
    }

    async doLogin(email: string, password: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/login`, { email: email, password: password })
                .subscribe({
                    next: (data: any) => {
                        this.router.navigate(['login/verify/' + data.verifyId]);
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);

                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });
        })
    }

    async doLogOut(autoNavigate = true): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/auth/logout`)
                .subscribe({
                    next: () => {
                        sessionStorage.clear();
                        localStorage.clear();
                        this.userdata.data.next(null);
                        this.cookieService.delete('idea_usersession');
                        resolve(true);

                        if (autoNavigate) {
                            this.router.navigate(['login']);
                        }
                    },
                    error: (err: HttpErrorResponse) => resolve(err.status),
                });
        })
    }

    protected async saveAndRedirect(data: any): Promise<void> {
        if (!data.userdata) return;
        localStorage.setItem('idea_apiKey', data.userdata.apiKey);
        localStorage.setItem('idea_userId', data.userdata.id);
        localStorage.removeItem('idea_loginemail')
        this.userdata.updateUserData(data.userdata);
        // console.log('userdata', data.userdata);
        this.userdata.checkUserBrowserLanguage(data.userdata);
    }

    async doPwForgotten(email: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/pwforgotten`, { email: email })
                .subscribe({
                    next: (data: any) => {
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });

        })
    }

    async doPwReset(resetid: string, password: string): Promise<boolean | number> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/setnewpw`, { resetid: resetid, password: password })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success('pwResetOk');
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });
        })
    }

    async doRegister(
        email: string,
        password: string,
        companyName: string,
        promotionData: any,
        silentRegistration: boolean = false,
        targetStreamId: string | undefined = undefined
    ): Promise<boolean | number> {
        return await new Promise(async (resolve) => {
            let url = `${serverurl}/auth/register`;
            if (promotionData) {
                url = `${serverurl}/auth/promotion/${promotionData.id}`;
            }
            //  Get browser language
            let browserLang = navigator.language || (navigator.languages && navigator.languages[0]) || 'en';
            if (browserLang !== 'en' && browserLang !== 'de') {
                browserLang = 'en';
            }
            this.http.post(
                url,
                {
                    email: email,
                    password: password,
                    lang: browserLang,
                    companyName: companyName,
                    promotionData: promotionData,
                    silentRegistration: silentRegistration
                }
            )
                .subscribe({
                    next: (data: any) => {
                        if (silentRegistration === true && targetStreamId) {
                            this.saveAndRedirect(data);

                            if (targetStreamId) this.goToTargetStream(targetStreamId);
                            else this.navigateByRole(data);

                            resolve(true);
                            return;
                        }
                        if (!data?.userdata || (data.userdata && data.userdata.status === "CONFIRM")) {
                            if (data.msg) this.mysnack.success(data.msg);
                            this.router.navigate(['login/congrat-signup']);
                        }
                        if (data.userdata && data.userdata.status === "ACTIVE") {
                            this.saveAndRedirect(data);
                            this.navigateByRole(data);
                        }

                        if (data.verifyId) {
                            this.router.navigate(['login/verify/' + data.verifyId]);
                        }
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });
        })
    }

    async registerByInviteId(
        email: string,
        password: string,
        inviteId: string,
        silentRegistration: boolean = false,
        targetStreamId: string | undefined = undefined,
        invitationProcessType?: MentorDetailsForRegistration['invitationProcessType'],
        customLoginFormData?: { id: string, value: string }[],
    ): Promise<boolean | number> {
        return await new Promise(async (resolve) => {
            this.http.post(
                `${serverurl}/auth/register/invite/${inviteId}`,
                {
                    email,
                    password,
                    silentRegistration,
                    targetStreamId,
                    ...(customLoginFormData?.length ? { customLoginFormData } : {}),
                },
            )
                .subscribe({
                    next: (data: any) => {
                        if (!data?.userdata || (data.userdata && data.userdata.status === "CONFIRM")) {
                            if (data.msg) this.mysnack.success(data.msg);

                            if (invitationProcessType === 'WITH_GRANT_ACCESS') {
                                this.router.navigate(['login/awaiting-access']);
                            } else {
                                this.router.navigate(['login/congrat-signup']);
                            }
                        }
                        if (data.userdata && data.userdata.status === "ACTIVE") {
                            this.saveAndRedirect(data);
                            this.navigateByRole(data);
                        }
                        if (silentRegistration === true) {
                            this.saveAndRedirect(data);

                            if (targetStreamId) this.goToTargetStream(targetStreamId);
                            else this.navigateByRole(data);

                            resolve(true);
                            return;
                        }
                        if (data.verifyId) {
                            this.router.navigate(['login/verify/' + data.verifyId]);
                        }
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.mysnack.error(err);
                        resolve(err.status);
                    }
                });
        });
    }
    async goToTargetStream(targetStreamId: string) {

        let stream = await this.genericStreamService.getOneGenericStream(targetStreamId);
        if (stream === false) {
            return
        }
        let result = await this.genericStreamService.createGenericUserStream(targetStreamId, "Your very first " + stream.name);
        if (result === false) {
            return
        }
        this.router.navigate(['generic-stream', result], { queryParams: { cid: targetStreamId } });
    }
}
